/* Favoris × OMES — page controller. Theme asset: assets/favoris.js (HO-07).
   Handoff: omes-workspace/assets/handoff/handoff-4-2026-10-12/favoris/ — the signals, ranking, filters, copy and countdown
   of src/favoris.logic.ts and reference/favoris.js, on the store's doors (see the three sections' headers):
     · saved pieces  = the theme's wishlist store in the browser (`at_wishlist`, product ids, newest first) and what this page
                       remembers of them (`at_wishlist_meta`: price and availability at first sight, when a piece came back);
                       the cards are drawn by Shopify (sections/favoris-cards.liquid) and finished here;
     · followed brands = the loyalty app (GET /apps/loyalty/brands), one board per brand drawn by Shopify
                       (sections/favoris-board.liquid) and finished here (new arrivals vs `at_brand_seen`, order, chips);
     · follows        = assets/omes-brand-follow.js owns every [data-follow][data-brand]; this script listens to its event;
     · bell alerts    = `at_event_alerts` in the browser (the handoff: sending belongs to the marketing automation);
     · add to cart    = POST cart_add_url, then the theme's cart drawer as the look page does (stl-looks.js). */
(function () {
  'use strict';
  var root = document.querySelector('[data-favoris-saved]');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function json(id) { var el = document.getElementById(id); if (!el) return {}; try { return JSON.parse(el.textContent); } catch (e) { return {}; } }
  var copy = Object.assign({}, json('favoris-copy'), json('favoris-followed-copy'));
  var fill = function (t, v) { return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return v[k] == null ? '' : v[k]; }); };
  var plural = function (n, one, other) { return fill(n > 1 ? other : one, { n: n }); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- storage (the theme's keys, plus this page's memory) ---- */
  var store = {
    get: function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var K = { wish: 'at_wishlist', meta: 'at_wishlist_meta', seen: 'at_brand_seen', alerts: 'at_event_alerts' };
  var wish = function () { var v = store.get(K.wish, []); return Array.isArray(v) ? v.map(String) : []; };
  var WEEK = 7 * 864e5;

  /* ---- money (the store's format, as stl-looks.js) ---- */
  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}} DT';
  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    var f = function (d, ts, ds) { var p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : ''); };
    var map = {
      amount: f(2, ',', '.'), amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','), amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_space_separator: f(2, ' ', ','), amount_no_decimals_with_space_separator: f(0, ' ', ','),
      amount_with_apostrophe_separator: f(2, "'", '.'), amount_with_period_and_space_separator: f(2, ' ', '.')
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return map[k] != null ? map[k] : map.amount; }).replace(/<[^>]+>/g, '');
  }
  /* 139,00 → 139 (money_without_trailing_zeros, which the cards use) */
  function moneyTrim(cents) { return formatMoney(cents).replace(/([.,])00(?=\D|$)/, ''); }

  /* ---- clock, dates ---- */
  var clock = function (ms) { ms = Math.max(0, ms); return Math.floor(ms / 864e5) + 'j ' + pad(Math.floor(ms % 864e5 / 36e5)) + ':' + pad(Math.floor(ms % 36e5 / 6e4)) + ':' + pad(Math.floor(ms % 6e4 / 1e3)); };
  var months = String(copy.months || 'janv.,févr.,mars,avr.,mai,juin,juil.,août,sept.,oct.,nov.,déc.').split(',');
  var weekdays = String(copy.weekdays || 'lundi,mardi,mercredi,jeudi,vendredi,samedi,dimanche').split(',');
  var dayLabel = function (ms) { var d = new Date(ms); return d.getDate() + ' ' + months[d.getMonth()]; };

  /* ---- toast ---- */
  var tt, toastEl = $('#toast'), tmsg = $('#tmsg'), tundo = $('#tundo');
  function toast(msg, undo) {
    if (!toastEl) return;
    tmsg.textContent = msg; tundo.hidden = !undo; toastEl.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('on'); }, undo ? 4000 : 2200);
  }

  /* ---- the page around the sections: header badge, mobile toolbar, the brands tab's address ---- */
  document.body.classList.add('favoris-page');
  function headerCount() {
    var n = wish().length;
    $$('#wishlistItems').forEach(function (b) { b.textContent = n; if (n) b.removeAttribute('data-zero'); else b.setAttribute('data-zero', ''); });
    if (window.checkWishlist) { try { window.checkWishlist(); } catch (e) {} }
  }
  function toolbarOffset() {
    var tb = $('.mbtlwraper'), h = tb && getComputedStyle(tb).display !== 'none' ? tb.getBoundingClientRect().height : 0;
    $$('.favoris').forEach(function (el) { el.style.setProperty('--favoris-toolbar', Math.round(h) + 'px'); });
  }
  window.addEventListener('resize', toolbarOffset); toolbarOffset();

  /* ---- rails ---- */
  function sync(t, a) { var el = $(t), ar = $(a); if (!el || !ar) return; ar.hidden = el.scrollWidth - el.clientWidth - el.scrollLeft < 4; }
  [['#ptrack', '#pnext'], ['#rtrack', '#rnext']].forEach(function (p) {
    var t = $(p[0]), a = $(p[1]); if (!t || !a) return;
    t.addEventListener('scroll', function () { sync(p[0], p[1]); }, { passive: true });
    a.addEventListener('click', function () { if (reduced) t.scrollLeft += t.clientWidth * 0.66; else t.scrollBy({ left: t.clientWidth * 0.66, behavior: 'smooth' }); });
    if (window.ResizeObserver) new ResizeObserver(function () { sync(p[0], p[1]); }).observe(t);
  });
  var syncAll = function () { sync('#ptrack', '#pnext'); sync('#rtrack', '#rnext'); };
  window.addEventListener('resize', syncAll); window.addEventListener('load', syncAll);

  /* ================= §2 Favoris — saved pieces ================= */
  var ptrack = $('#ptrack'), pall = $('#pall'), sum = $('#sum');
  var low = parseInt(root.getAttribute('data-low-stock'), 10) || 2;
  var state = { auth: false, followed: [], undo: null, menu: null, filter: 'all' };

  function sizesOf(card) { try { return JSON.parse(card.getAttribute('data-sizes') || '[]'); } catch (e) { return []; } }
  /* Per size: available when one of its variants is, units = the tracked variants' sum. */
  function sizeState(card) {
    var by = {}, order = [];
    sizesOf(card).forEach(function (v) {
      var e = by[v.s]; if (!e) { e = by[v.s] = { s: v.s, a: false, q: 0, tracked: false }; order.push(e); }
      e.a = e.a || !!v.a; if (v.q != null) { e.tracked = true; e.q += Number(v.q) || 0; }
    });
    var first = null; for (var i = 0; i < order.length; i++) { if (order[i].a) { first = order[i]; break; } }
    return { sizes: order, first: first };
  }
  /* The alert (drop › back › low), the badge, the price row, the size line, the note, the labels. */
  function decorate(card, meta) {
    var price = +card.getAttribute('data-price'), compare = +card.getAttribute('data-compare') || 0;
    var avail = card.getAttribute('data-available') === 'true', oneSize = card.getAttribute('data-one-size') === 'true';
    var st = sizeState(card), first = st.first, kind = null, rank = 3, remaining = 0, now = Date.now();
    /* « De retour » and « Plus que n » speak of a size (src/favoris.logic.ts: entry.size is required): a one-size piece only gets « Prix en baisse ». */
    if (meta.p > price) { kind = 'drop'; rank = 0; }
    else if (!oneSize && avail && meta.back && now - meta.back < WEEK) { kind = 'back'; rank = 1; }
    else if (!oneSize && first && first.tracked && first.q > 0 && first.q <= low) { kind = 'low'; rank = 2; remaining = first.q; }
    card.setAttribute('data-rank', rank); card.setAttribute('data-kind', kind || '');
    var sizeName = first ? first.s : (st.sizes[0] ? st.sizes[0].s : '');
    var badge = $('.badge', card);
    if (kind) { badge.hidden = false; badge.className = 'badge ' + kind; badge.textContent = kind === 'drop' ? copy.dropBadge : kind === 'back' ? copy.backBadge : fill(copy.lowBadge, { n: remaining }); }
    else badge.hidden = true;
    var was = kind === 'drop' ? meta.p : (compare > price ? compare : 0), pr = $('.pr', card);
    if (was > price) { var pct = Math.round((1 - price / was) * 100); pr.innerHTML = '<u>' + esc(moneyTrim(price)) + '</u><s>' + esc(moneyTrim(was)) + '</s><em>-' + pct + ' %</em>'; }
    $('.sz', card).textContent = oneSize ? copy.oneSize : fill(copy.sizeLabel, { size: sizeName });
    var sig = $('.sig', card);
    if (kind === 'back') { sig.hidden = false; sig.className = 'sig back'; sig.textContent = fill(copy.backNote, { size: sizeName }); }
    else if (kind === 'low') { sig.hidden = false; sig.className = 'sig low'; sig.textContent = fill(copy.lowNote, { n: remaining, size: sizeName }); }
    else sig.hidden = true;
    $('.rb.x', card).setAttribute('aria-label', copy.removeLabel);
    $('.rb.dots', card).setAttribute('aria-label', copy.moreLabel);
    $('.rb.bag', card).setAttribute('aria-label', copy.addLabel);
    var brand = card.getAttribute('data-brand');
    $('[data-act="brand"]', card).textContent = copy.menuBrand;
    var f = $('[data-act="follow"]', card);
    if (f) { f.setAttribute('data-follow-text', fill(copy.menuFollow, { brand: brand })); f.setAttribute('data-following', fill(copy.menuUnfollow, { brand: brand })); delete f.dataset.followIdle; f.textContent = f.getAttribute('data-follow-text'); }
    $('[data-act="share"]', card).textContent = copy.menuShare;
  }
  function renderEmpty() {
    ptrack.innerHTML = '<div class="empty"><h3>' + esc(copy.emptyTitle) + '</h3><p>' + esc(copy.emptyBody) + '</p></div>';
    if (pall) pall.hidden = true;
  }
  function loadPieces() {
    var ids = wish(); headerCount();
    sum.textContent = plural(ids.length, copy.countOne, copy.countOther);
    if (!ids.length) { renderEmpty(); syncAll(); return Promise.resolve(); }
    var url = root.getAttribute('data-search-url') + '?type=product&section_id=favoris-cards&q=' + encodeURIComponent(ids.map(function (i) { return 'id:' + i; }).join(' OR '));
    return fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }).then(function (html) {
      var box = document.createElement('div'); box.innerHTML = html;
      var byId = {}; $$('.card', box).forEach(function (c) { byId[c.getAttribute('data-id')] = c; });
      var cards = ids.map(function (i) { return byId[i]; }).filter(Boolean);
      var meta = store.get(K.meta, {}), now = Date.now(), kept = {};
      cards.forEach(function (c) {
        var id = c.getAttribute('data-id'), price = +c.getAttribute('data-price'), avail = c.getAttribute('data-available') === 'true';
        var m = meta[id] || { p: price, so: !avail, t: now };
        if (!avail) m.so = true;
        else if (m.so) { m.so = false; m.back = now; }
        kept[id] = m; decorate(c, m);
      });
      store.set(K.meta, kept);
      cards.sort(function (a, b) { return (+a.getAttribute('data-rank')) - (+b.getAttribute('data-rank')) || ids.indexOf(a.getAttribute('data-id')) - ids.indexOf(b.getAttribute('data-id')); });
      ptrack.innerHTML = '';
      if (!cards.length) renderEmpty(); else { cards.forEach(function (c) { ptrack.appendChild(c); }); if (pall) pall.hidden = false; }
      sum.textContent = plural(cards.length, copy.countOne, copy.countOther);
      applyFollowState(); syncAll();
    });
  }
  function closeMenu() { if (!state.menu) return; state.menu.hidden = true; var b = $('[data-menu]', state.menu.parentNode); if (b) b.setAttribute('aria-expanded', 'false'); state.menu = null; }
  function removePiece(card) {
    var id = card.getAttribute('data-id'), ids = wish(), idx = ids.indexOf(id);
    if (idx < 0) return;
    state.undo = { id: id, idx: idx, card: card, next: card.nextElementSibling };
    ids.splice(idx, 1); store.set(K.wish, ids); headerCount();
    card.classList.add('out');
    setTimeout(function () { if (card.parentNode) card.parentNode.removeChild(card); var left = $$('.card', ptrack).length; sum.textContent = plural(left, copy.countOne, copy.countOther); if (!left) renderEmpty(); syncAll(); }, reduced ? 0 : 250);
    toast(copy.removed, true);
  }
  if (tundo) tundo.addEventListener('click', function () {
    var u = state.undo; if (!u) return; state.undo = null; toastEl.classList.remove('on');
    var ids = wish(); if (ids.indexOf(u.id) < 0) { ids.splice(Math.min(u.idx, ids.length), 0, u.id); store.set(K.wish, ids); }
    headerCount(); u.card.classList.remove('out');
    var empty = $('.empty', ptrack); if (empty) empty.parentNode.removeChild(empty);
    if (u.next && u.next.parentNode === ptrack) ptrack.insertBefore(u.card, u.next); else ptrack.appendChild(u.card);
    sum.textContent = plural($$('.card', ptrack).length, copy.countOne, copy.countOther); if (pall) pall.hidden = false; syncAll();
  });
  function addToCart(card) {
    var variant = card.getAttribute('data-variant'); if (!variant) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: Number(variant), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    var bag = $('.rb.bag', card); bag.setAttribute('aria-busy', 'true');
    fetch(root.getAttribute('data-cart-add-url') || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var drawn = !!(cart && typeof cart.renderContents === 'function' && j.sections);
        if (drawn) cart.renderContents(j);
        var after = window.OmesBundles ? window.OmesBundles.reconcile().catch(function () { return null; }) : Promise.resolve();
        return after.then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (!drawn) { var st = sizeState(card), size = st.first ? st.first.s : ''; toast(fill(card.getAttribute('data-one-size') === 'true' || !size ? copy.added : copy.addedSize, { brand: card.getAttribute('data-brand'), size: size })); }
        });
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Article indisponible'); })
      .then(function () { bag.removeAttribute('aria-busy'); });
  }
  function share(card) {
    var url = card.getAttribute('data-href') ? (card.querySelector('[data-act="share"]').getAttribute('data-href') || card.getAttribute('data-href')) : location.href;
    if (navigator.share) { navigator.share({ title: card.getAttribute('data-title'), url: url }).catch(function () {}); return; }
    var done = function () { toast(copy.share); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
  }
  ptrack.addEventListener('click', function (e) {
    var mb = e.target.closest('[data-menu]'), act = e.target.closest('[data-act]'), rm = e.target.closest('[data-rm]'), add = e.target.closest('[data-add]');
    if (mb) {
      e.preventDefault(); var menu = $('.menu', mb.parentNode), open = state.menu === menu; closeMenu();
      if (!open) { menu.hidden = false; mb.setAttribute('aria-expanded', 'true'); state.menu = menu; }
      return;
    }
    if (act) {
      var card = act.closest('.card'), a = act.getAttribute('data-act');
      if (a === 'brand') { e.preventDefault(); closeMenu(); window.location.href = act.getAttribute('data-href'); return; }
      if (a === 'share') { e.preventDefault(); closeMenu(); share(card); return; }
      closeMenu(); return; /* follow: omes-brand-follow.js takes the click */
    }
    if (rm) { e.preventDefault(); removePiece(rm.closest('.card')); return; }
    if (add) { e.preventDefault(); addToCart(add.closest('.card')); }
  });
  document.addEventListener('click', function (e) { if (state.menu && !e.target.closest('.menu,[data-menu]')) closeMenu(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.menu) closeMenu(); });

  /* ================= §3 Marques suivies ================= */
  var F = document.querySelector('[data-favoris-followed]');
  var boards = $('#boards'), chipsEl = $('#bchips'), actsum = $('#actsum'), signin = $('#bsignin'), bempty = $('#bempty');
  var RANK = { live: 0, oclub: 1, soon: 2, new: 3, quiet: 9 };
  var isEv = function (k) { return k === 'live' || k === 'soon' || k === 'oclub'; };
  function seenMap() { var v = store.get(K.seen, {}); return v && typeof v === 'object' ? v : {}; }
  function alerts() { var v = store.get(K.alerts, []); return Array.isArray(v) ? v : []; }
  /* Finish a board drawn by Shopify: the `new` signal, the status line, the bell. */
  function prepareBoard(b, order) {
    var kind = b.getAttribute('data-kind') || 'quiet', name = b.getAttribute('data-name'), handle = b.getAttribute('data-b');
    var tx = $('.tx', b), own = $('.own', b), text = '';
    if (kind === 'quiet') {
      var seen = seenMap()[handle], created = [];
      try { created = JSON.parse(b.getAttribute('data-created') || '[]'); } catch (e) {}
      if (seen) {
        var fresh = created.filter(function (s) { return s * 1000 > seen; });
        if (fresh.length) {
          kind = 'new'; var oldest = Math.min.apply(null, fresh) * 1000, days = (Date.now() - oldest) / 864e5, since;
          if (days < 1) since = copy.sinceToday; else if (days < 2) since = copy.sinceYesterday; else { var wd = (new Date(oldest).getDay() + 6) % 7; since = fill(copy.sinceWeekday, { day: weekdays[wd] }); }
          text = fill(fresh.length > 1 ? copy.statusNewOther : copy.statusNewOne, { n: fresh.length, since: since });
          var ind = $('.own img', b); if (ind) { var i = document.createElement('i'); i.className = 'ind new'; ind.parentNode.replaceChild(i, ind); }
        }
      }
      if (kind === 'quiet') {
        var city = b.getAttribute('data-city'), n = b.getAttribute('data-count');
        text = city ? fill(copy.statusQuiet, { city: city, n: n }) : fill(copy.statusQuiet, { city: '', n: n }).replace(/^\s*·\s*/, '');
      }
    } else if (kind === 'live') {
      text = fill(copy.statusLive, { countdown: '<span data-clock="' + b.getAttribute('data-end') + '">' + clock(+b.getAttribute('data-end') - Date.now()) + '</span>' });
    } else if (kind === 'soon') {
      text = fill(copy.statusSoon, { title: esc(b.getAttribute('data-ev-title') || ''), date: dayLabel(+b.getAttribute('data-start')) });
    }
    b.className = 'board k-' + kind; b.setAttribute('data-kind', kind); b.setAttribute('data-rank', RANK[kind]); b.setAttribute('data-order', order);
    if (tx) tx.innerHTML = text;
    var bell = $('.bell', b); if (bell) setBell(bell, alerts().indexOf(bell.getAttribute('data-ntf')) > -1);
  }
  function setBell(bell, on) { bell.classList.toggle('on', on); bell.setAttribute('aria-pressed', on ? 'true' : 'false'); bell.setAttribute('aria-label', on ? copy.bellOn : copy.bellOff); bell.setAttribute('title', on ? copy.bellOn : copy.bellOff); }
  function allBoards() { return $$('.board', boards); }
  function matches(b, f) { var k = b.getAttribute('data-kind'); return f === 'all' || (f === 'events' ? isEv(k) : k === 'new'); }
  function renderBoards() {
    if (!F) return;
    var list = allBoards().sort(function (a, b) { return (+a.getAttribute('data-rank')) - (+b.getAttribute('data-rank')) || (+a.getAttribute('data-order')) - (+b.getAttribute('data-order')); });
    list.forEach(function (b) { boards.appendChild(b); });
    var chips = [{ id: 'all', label: copy.filterAll }, { id: 'events', label: copy.filterEvents }, { id: 'new', label: copy.filterNew }]
      .map(function (c) { c.n = list.filter(function (b) { return matches(b, c.id); }).length; return c; })
      .filter(function (c) { return c.id === 'all' || c.n; });
    if (!chips.some(function (c) { return c.id === state.filter; })) state.filter = 'all';
    chipsEl.innerHTML = chips.map(function (c) { var on = c.id === state.filter; return '<button type="button" class="chip' + (on ? ' on' : '') + '" data-bf="' + c.id + '" aria-pressed="' + on + '">' + esc(c.label) + '<em>' + c.n + '</em></button>'; }).join('');
    list.forEach(function (b) { b.hidden = !matches(b, state.filter); });
    var active = list.filter(function (b) { return b.getAttribute('data-kind') !== 'quiet'; }).length;
    actsum.textContent = plural(list.length, copy.fCountOne, copy.fCountOther) + (active ? fill(copy.active, { n: active }) : '');
    if (bempty) bempty.hidden = !!list.length;
    boards.hidden = !list.length;
  }
  function fetchBoard(handle) {
    return fetch(F.getAttribute('data-board-url') + '/' + encodeURIComponent(handle) + '?section_id=' + F.getAttribute('data-board-section'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; })
      .then(function (html) { var box = document.createElement('div'); box.innerHTML = html; return $('.board', box); });
  }
  /* The OMES account's follows first (localStorage `omes_customer`, the contract with assets/mon-compte.js): the
     marketplace's /account/brands answered in the proxy's shape; the loyalty proxy for a Shopify-signed customer.
     Mirror of the helper in assets/omes-brand-follow.js. */
  var ACCOUNT_API = (window.omesApiBase || 'https://partenaires.omes.tn') + '/api/storefront/v1';
  function accountToken() { try { var s = JSON.parse(localStorage.getItem('omes_customer') || 'null'); return s && s.token && (!s.expiresAt || Date.parse(s.expiresAt) > Date.now()) ? s.token : null; } catch (e) { return null; } }
  function accountFollows(token) {
    return fetch(ACCOUNT_API + '/account/brands', { headers: { Accept: 'application/json', 'X-Customer-Token': token }, mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (!d || !Array.isArray(d.brands)) return { authenticated: false, followed: [] }; var followed = d.brands.map(function (b) { return b.handle; }).reverse(); return { authenticated: true, followed: followed, max: Number(d.max) || 0, remaining: Math.max(0, (Number(d.max) || 0) - followed.length), reward: Number(d.reward) || 0 }; });
  }
  function loadFollowed() {
    var token = accountToken();
    return (token ? accountFollows(token) : fetch(root.getAttribute('data-loyalty-url'), { credentials: 'include', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }))
      .catch(function () { return null; })
      .then(function (data) {
        state.auth = !!(data && data.authenticated);
        state.followed = state.auth && Array.isArray(data.followed) ? data.followed.map(String) : [];
        applyFollowState(); applyDiscover();
        if (!F) return;
        if (!state.auth) { signin.hidden = false; boards.hidden = true; chipsEl.innerHTML = ''; actsum.textContent = ''; if (bempty) bempty.hidden = true; return; }
        signin.hidden = true;
        return Promise.all(state.followed.map(fetchBoard)).then(function (list) {
          boards.innerHTML = '';
          list.forEach(function (b, i) { if (!b) return; prepareBoard(b, i); boards.appendChild(b); });
          renderBoards();
        });
      });
  }
  if (F) {
    chipsEl.addEventListener('click', function (e) { var c = e.target.closest('[data-bf]'); if (!c) return; state.filter = state.filter === c.getAttribute('data-bf') ? 'all' : c.getAttribute('data-bf'); renderBoards(); });
    boards.addEventListener('click', function (e) {
      var n = e.target.closest('[data-ntf]');
      if (n) { e.preventDefault(); e.stopPropagation(); var id = n.getAttribute('data-ntf'), list = alerts(), on = list.indexOf(id) > -1; store.set(K.alerts, on ? list.filter(function (x) { return x !== id; }) : list.concat([id])); setBell(n, !on); toast(on ? copy.alertOff : copy.alertOn); return; }
      var b = e.target.closest('[data-b]');
      if (b) { var seen = seenMap(); seen[b.getAttribute('data-b')] = Date.now(); store.set(K.seen, seen); window.location.href = b.getAttribute('data-href'); }
    });
    boards.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-b]')) { e.preventDefault(); e.target.click(); } });
    setInterval(function () { $$('[data-clock]').forEach(function (el) { el.textContent = clock(+el.getAttribute('data-clock') - Date.now()); }); }, 1000);
  }

  /* ================= §4 Marques à découvrir ================= */
  var D = document.querySelector('[data-favoris-discover]'), band = $('#radar'), rtrack = $('#rtrack');
  function applyDiscover() {
    if (!D) return;
    var shown = 0;
    $$('.board[data-r]', rtrack).forEach(function (b) { var hide = state.followed.indexOf(b.getAttribute('data-r')) > -1; b.hidden = hide; if (!hide) shown++; });
    band.hidden = !shown; syncAll();
  }

  /* ---- follow state on every button this page draws (omes-brand-follow.js seeded only the buttons present at load) ---- */
  function applyFollowState() {
    $$('.favoris [data-follow][data-brand]').forEach(function (el) {
      var on = state.followed.indexOf((el.getAttribute('data-brand') || '').trim()) > -1;
      el.classList.toggle('is-following', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var idle = el.getAttribute('data-follow-text') || el.textContent.trim(); el.textContent = on ? (el.getAttribute('data-following') || idle) : idle;
    });
  }
  /* A follow saved anywhere on the page: the brand moves between §3 and §4, the ⋯ menus follow, a toast says so
     (on a follow the theme's own notice already says it with the points earned, so only the unfollow gets this page's toast). */
  document.addEventListener('omes:brand-follow-change', function (e) {
    var d = e.detail || {}, brand = String(d.brand || ''), on = !!d.following; if (!brand) return;
    var i = state.followed.indexOf(brand);
    if (on && i < 0) state.followed.push(brand); if (!on && i > -1) state.followed.splice(i, 1);
    applyFollowState(); applyDiscover();
    var name = brand; var src = $('.board[data-r="' + brand + '"] b', rtrack) || $('.card[data-brand-handle="' + brand + '"]', ptrack);
    if (src) name = src.getAttribute('data-brand') || src.textContent.trim();
    if (!on) { var gone = $('.board[data-b="' + brand + '"]', boards); if (gone) gone.parentNode.removeChild(gone); renderBoards(); toast(fill(copy.unfollow, { brand: name })); return; }
    if (F && state.auth) fetchBoard(brand).then(function (b) { if (!b) return; if ($('.board[data-b="' + brand + '"]', boards)) return; prepareBoard(b, state.followed.length - 1); boards.appendChild(b); renderBoards(); });
    setTimeout(function () { if (!$('.omes-follow-notice')) toast(fill(copy.follow, { brand: name })); }, 150);
  });

  /* ---- go ---- */
  loadPieces().then(loadFollowed).then(function () {
    if (/[?&]vue=marques/.test(location.search) && F) $('#brands').scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
})();
